import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Solutions from './components/Solutions';
import Process from './components/Process';
import Benefits from './components/Benefits';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <About />
      <Solutions />
      <Process />
      <Benefits />
      <Contact />
      <Footer />
    </div>
  );
}
